/**
 *  31/07/2023 v 1.0 - JuanMa
 **/

export const setToString= (setOrigen) => {

    console.log ("setToString: " + setOrigen);
    let cadena= "";
    if (setOrigen.size > 0 )
    {
        setOrigen.forEach((elemento) => {
            if (cadena != "")
                cadena+= ",";
            cadena+= elemento;
        });
    }
    console.log("cadena: ", cadena);
    return cadena;
}

